import React from "react";
import Upload from "rc-upload";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import classNames from 'classnames';
import lottie from 'lottie-web';
import styles from "./blackBoardUpload.module.scss";
import uploadAniData from '../../assets/lottie/upload.json';
import ImageProcess from './ImageProcess';
import { readImage } from './utils';
import Loading from '../../components/Common/Loading';
// import queryParser from 'query-string';
import common from '../../common/common';
import { Commun } from '../../utils/axios';

const isMeike = window.location.host.includes("metcom");

class BlackBoardUpload extends React.Component {
  initImage = '';
  cropper;
  uploadAni = null;
  uploadDivRef = React.createRef();
  imageProcess;
  searchParam = {};
  constructor(props) {
    super(props);
    this.state = {
      image: '',
      status: 0,
      loading: false,
      isRevised: false,
    };
  }

  componentDidMount() {
    const searchParam = common.getSearchParam();
    this.searchParam = searchParam;
    this.uploadAni = lottie.loadAnimation({
      animationData: uploadAniData,
      container: this.uploadDivRef.current,
      autoplay: true,
      loop: true,
      renderer: 'svg',
    });
  }

  beforeUpload = (file) => {
    if (this.state.loading) return;
    this.setState({
      loading: true,
    });
    const imageUrl = readImage(file);
    this.setState({
      image: imageUrl,
      loading: false,
    });
    this.initImage = imageUrl;
    return false;
  };

  closeCropper = () => {
    this.setState({
      image: '',
      status: 0,
      loading: false,
      isRevised: false,
    });
    this.initImage = '';
  };

  rotateImage = (degree) => {
    if (this.state.loading) return;
    this.setState({
      loading: true
    }, () => {
      let img = new Image();
      img.src = this.state.image;
      let canvas = document.createElement("CANVAS");
      img.onload = () => {
        canvas.width = img.height;
        canvas.height = img.width;
        let context = canvas.getContext('2d');
        context.rotate(degree * Math.PI / 180);
        if (degree === 90) {
          context.drawImage(img, 0, -img.height);
        } else if (degree === -90) {
          context.drawImage(img, -img.width, 0);
        }
        canvas.toBlob((blob) => {
          const imageUrl = readImage(blob);
          this.setState({
            image: imageUrl,
            loading: false,
          })
        });
      }
    });
  };

  reset = () => {
    if (this.state.loading) return;
    this.setState({
      image: this.initImage,
      loading: false,
      isRevised: false,
    }, () => { this.cropper.reset(); });
  };

  uploadImage = () => {
    if (this.state.loading) return;
    this.cropper.getCroppedCanvas().toBlob((blob) => {
      const imageUrl = readImage(blob);
      console.log(imageUrl);
      this.setState({ image: '', status: 1 }, () => { this.uploadAni.playSegments([1, 83], true); });
      let formData = new FormData();
      formData.append('file', new File([blob], 'image.jpg'));
      formData.append('key', this.searchParam.key);
      Commun.post('/api/blackboard/upload', formData).then((res) => {
        console.log(res);
        this.uploadAni.loop = false;
        this.uploadAni.playSegments([84, 160], true);
        this.uploadAni.addEventListener('complete', () => {
          this.setState({ status: 2 });
        });
      }).catch(e => {
        this.setState({ status: 3 });
      });
    }, "image/jpeg", 0.95);
  };

  reviseImage = () => {
    if (this.state.loading || this.state.isRevised) return;
    const cv = window.cv;
    this.setState({
      loading: true,
    }, () => {
      setTimeout(() => {
        this.imageProcess = new ImageProcess();
        if (this.imageProcess.isError) {
          console.log('opencv.js初始化失败');
          return;
        }
        let _img = new Image();
        _img.src = this.state.image;
        _img.onload = () => {
          let src = cv.imread(_img);
          let canvas = this.imageProcess.revise(src);
          if (canvas) {
            canvas.toBlob(blob => {
              const url = readImage(blob);
              this.setState({
                image: url,
                loading: false,
                isRevised: true,
              })
            })
          } else {
            this.setState({
              loading: false
            })
          }
        };
      }, 10);
    });
    return;
  };

  render() {
    const { image, status, loading } = this.state;
    return (
      <div className={styles.container}>
          <div style={{ display: image ? 'none' : 'block' }}>
            <div className={styles.header}>
              <span className={classNames(styles.logo, isMeike ? styles.meikeLogo : '')}></span>
            </div>
            {status === 0 && <div className={styles.wrapper}>
              <span className={classNames(styles.pic, styles.selectPic)}></span>
              <p className={styles.p1}>选择照片</p>
              <p className={styles.p2}>本次上传10分钟内有效，过期请重新扫码</p>
            </div>}
            <div className={styles.wrapper} style={{ display: status === 1 ? 'flex' : 'none' }}>
              <span className={styles.pic} ref={this.uploadDivRef}></span>
              <p className={styles.p1}>上传中...</p>
              <p className={styles.p2}>图片上传中，请稍等一会 </p>
            </div>
            {status === 2 && <div className={styles.wrapper}>
              <span className={classNames(styles.pic, styles.successPic)}></span>
              <p className={styles.p1}>上传成功</p>
              <p className={styles.p2}>请在云教室客户端里查看照片</p>
            </div>}
            {status === 3 && <div className={styles.wrapper}>
              <span className={classNames(styles.pic, styles.failPic)}></span>
              <p className={styles.p1}>失败了！</p>
              <p className={styles.p2}>图片上传失败，请重新扫码二维码</p>
            </div>}
            {status === 0 && <div className={styles.footer}>
              <Upload accept="image/*" beforeUpload={this.beforeUpload}>
                <div className={styles.uploadBtn}>
                  <span className={styles.uploadIcon}></span>
                  <span className={styles.uploadText}>现在上传</span>
                </div>
              </Upload>
            </div>}
          </div>
          {
            image && (
              <div className={styles.uploadContainer}>
                <div className={styles.cropperContainer} style={{ display: 'flex', flexDirection: 'column' }}>
                  <Cropper
                    style={{ maxWidth: '80%', maxHeight: '90%' }}
                    src={image}
                    viewMode={1}
                    guides={true}
                    minCropBoxHeight={100}
                    minCropBoxWidth={100}
                    background={false}
                    responsive={true}
                    autoCropArea={1}
                    dragMode="none"
                    checkOrientation={false}
                    onInitialized={(instance) => {
                      this.cropper = instance;
                    }}
                  />
                  {/* <canvas id='outputCanvas' style={{ maxWidth: '80%', maxHeight: '90%' }} /> */}
                </div>
                <div className={styles.operations}>
                  <div className={styles.operation} onClick={this.reset}>
                    <span className={classNames(styles.icon, styles.reset)}></span>
                    <span className={styles.operationText}>还原</span>
                  </div>
                  <div className={styles.operation} onClick={() => this.rotateImage(90)}>
                    <span className={classNames(styles.icon, styles.left)}></span>
                    <span className={styles.operationText}>向左90º</span>
                  </div>
                  <div className={styles.operation} onClick={() => this.rotateImage(-90)}>
                    <span className={classNames(styles.icon, styles.right)}></span>
                    <span className={styles.operationText}>向右90º</span>
                  </div>
                  <div className={styles.operation} onClick={this.reviseImage}>
                    <span className={classNames(styles.icon, styles.revise)}></span>
                    <span className={styles.operationText}>自动校正</span>
                  </div>
                </div>
                <div className={styles.bottom}>
                  <button className={classNames(styles.cancelBtn, styles.btn)} onClick={this.closeCropper}>取消</button>
                  <button className={classNames(styles.uploadBtn, styles.btn)} onClick={this.uploadImage}>上传</button>
                </div>
              </div>
            )
          }
        <Loading loading={loading} text='正在处理中...' />
      </div>
    );
  }
}
export default BlackBoardUpload;
